import { Team } from 'utils/graphql/models/Team';

export interface Tree<T> {
  data: T;
  key: string;
  children?: Tree<T>[];
  disabled?: boolean;
}

export const getTeamsTree = (teams: Team[], disabledTeamIds: number[] = []) => {
  const teamMap = teams.reduce(
    (acc, team) => {
      acc[team.id] = {
        data: team,
        key: team.id.toString(),
        children: undefined,
        disabled: disabledTeamIds.includes(team.id) || undefined,
      };

      return acc;
    },
    {} as Record<string, Tree<Team>>,
  );

  const tree: Tree<Team>[] = [];

  teams.forEach((team) => {
    const parent = team.parentTeam?.id ? teamMap[team.parentTeam?.id] : undefined;

    if (parent) {
      parent.children = parent.children || [];
      parent.children.push(teamMap[team.id]);
    } else {
      tree.push(teamMap[team.id]);
    }
  });

  return tree;
};

interface OptionsTree {
  title: string;
  value: number;
  children: OptionsTree[];
  disabled?: boolean;
}

export const getTeamsOptionsTree = (tree: Tree<Team>[]): OptionsTree[] => {
  return tree.map((item) => {
    const option: OptionsTree = {
      title: item.data.label,
      value: item.data.id,
      disabled: item.disabled,
      children: item.children ? getTeamsOptionsTree(item.children) : [],
    };

    return option;
  });
};

export const teamsToOptionsTree = (teams: Team[], disabledTeamIds: number[] = []): OptionsTree[] => {
  const tree = getTeamsTree(teams, disabledTeamIds);

  const optionsTree = getTeamsOptionsTree(tree);

  return optionsTree;
};
